import '@/assets/styles/app.scss'
import Buefy from 'buefy'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import utilsMixin from '@/mixins/utils'

// Font awesome

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowUp,
  faBan,
  faBars,
  faBell,
  faBox,
  faBoxOpen,
  faCalendarAlt,
  faCaretDown,
  faCheck,
  faCheckCircle,
  faClock,
  faCog,
  faCopy,
  faDoorOpen,
  faDownload,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faFile,
  faFileExcel,
  faFilter,
  faHashtag,
  faInfoCircle,
  faMinus,
  faMobileAlt,
  faPause,
  faPencilAlt,
  faPeopleArrows,
  faPlay,
  faPlus,
  faPrint,
  faSearch,
  faSitemap,
  faStopwatch,
  faSyncAlt,
  faTimes,
  faTrashAlt,
  faUpload,
  faUserCheck
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'

import {
  faCheckSquare,
  faClock as faClockOutline,
  faMap,
  faMinusSquare,
  faSquare
} from '@fortawesome/free-regular-svg-icons'

library.add(
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faArrowUp,
  faBan,
  faBars,
  faBell,
  faBox,
  faBoxOpen,
  faCalendarAlt,
  faCaretDown,
  faCheck,
  faCheckSquare,
  faCheckCircle,
  faClock,
  faClockOutline,
  faCog,
  faCopy,
  faDoorOpen,
  faDownload,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faEye,
  faFile,
  faFileExcel,
  faFilter,
  faHashtag,
  faInfoCircle,
  faMap,
  faMinus,
  faMinusSquare,
  faMobileAlt,
  faPause,
  faPencilAlt,
  faPeopleArrows,
  faPlay,
  faPlus,
  faPrint,
  faSearch,
  faSitemap,
  faSquare,
  faStopwatch,
  faSyncAlt,
  faTimes,
  faTrashAlt,
  faUpload,
  faUserCheck,
  faWhatsapp
)

Vue.component('FontAwesomeIcon', FontAwesomeIcon)

Vue.use(Buefy, {
  defaultIconComponent: 'FontAwesomeIcon',
  defaultIconPack: 'fas'
})
Vue.mixin(utilsMixin)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
